import React from "react";

import { Props } from "./types";
import { Controls } from "./controls";
import { CloseAll } from "./controls/closeAll";
import { OpenAll } from "./controls/openAll";
import { Context } from "./context";
import { useControls, useToggle, useUtils } from "./utils";

function TreeToggle(props: Props) {
  const [hasUsedControls, setHasUsedControls] = React.useState(false);
  const [maxDepth, setMaxDepth] = React.useState(0);
  const [mappedEl, setMappedEl] = React.useState<{
    [key: string]: { isOpen: boolean; depth: number };
  }>({});
  const deepestOpenedLevel = Object.values(mappedEl).reduce(
    (maxDepth, { isOpen, depth }) =>
      isOpen ? Math.max(maxDepth, depth) : maxDepth,
    0,
  );

  return (
    <Context.Provider
      value={{
        maxDepth,
        mappedEl,
        deepestOpenedLevel,
        setMappedEl: (mpEl) => {
          !hasUsedControls && setHasUsedControls(true);
          setMappedEl(mpEl);
        },
        initialize: (key, depth, isOpen) => {
          hasUsedControls
            ? setMappedEl((m) => ({
                ...m,
                [key]: {
                  isOpen: deepestOpenedLevel <= depth ? false : isOpen,
                  depth,
                },
              }))
            : setMappedEl((m) => ({ ...m, [key]: { isOpen, depth } }));
          maxDepth < depth && setMaxDepth(depth);
        },
        close: (key, depth) => {
          setMappedEl((m) => ({ ...m, [key]: { isOpen: false, depth } }));
          maxDepth < depth && setMaxDepth(depth);
        },
        open: (key, depth) => {
          setMappedEl((m) => ({ ...m, [key]: { isOpen: true, depth } }));
          maxDepth < depth && setMaxDepth(depth);
        },
      }}
    >
      {props.children}
    </Context.Provider>
  );
}
export {
  TreeToggle,
  Controls,
  CloseAll,
  OpenAll,
  useControls,
  useToggle,
  useUtils,
};
